import React from 'react';

type Props = {
    color?: string;
    size?: string;
    className?: string;
}

const Cursor = ({ color = 'fill-primary-gray-950', size = 'size-3', className = '' }: Props) => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${size} ${className}`}>
            <path className={`cursor ${color}`} d="M12 -5.00652e-07L0.84645 2.98858L9.01142 11.1536L12 -5.00652e-07ZM2 10L2.70711 10.7071L6.34315 7.07107L5.63604 6.36396L4.92893 5.65685L1.29289 9.29289L2 10Z" />
        </svg>
    );
}

export default Cursor;